import React from "react"
import { useState } from "react"
import PublicationTypeSelector from "./PublicationTypeSelector.tsx"
import SimplePublicationModal from "./SimplePublicationModal.tsx"
import ProductPublicationModal from "./ProductPublicationModal.tsx"
import { connect } from "react-redux"
import { closeFeedTextModal, createPost, openFeedTextModal, setPortfolio } from "../../../store/actions/index.js"

type ModalStep = "selector" | "simple" | "product"

interface MainFeedModalProps {
  isOpen: boolean
  createPost: (data: any) => void
    setPortfolio: (data: any, images: any) => void
 closeFeedTextModal: () => void
  userData: {
    image_profile: string
    name: string
    last_name?: string
    razon_social?: string
    type: string
  }
  onPublishSimple: (data: {
    content: string
    images?: File
    video?: File
  }) => void
  onPublishProduct: (data: {
    name: string
    description: string
    startDate: string
    endDate: string
    zone: string
    images: File[]
    type: string
    priceUnit: string
    price: string
    currencyType: string
  }) => void
}

const MainFeedModal: React.FC<MainFeedModalProps> = ({
    closeFeedTextModal,
    createPost,
    userData,
    setPortfolio,
    onPublishProduct,
}) => {
    const [currentStep, setCurrentStep] = useState<ModalStep>("selector")


  const handleSelectType = (type: "simple" | "product") => {
    setCurrentStep(type)
  }

  const handleBack = () => {
    setCurrentStep("selector")
  }

  const handleClose = () => {
    setCurrentStep("selector")
    closeFeedTextModal()
  }

  const handlePublishSimple = (data: any) => {
    createPost(data)

    handleClose()
  }

  const handlePublishProduct = (data: any) => {
    setPortfolio(data, data.images)
    handleClose()
  }

  return (
    <>
      {currentStep === "selector" && (
        <PublicationTypeSelector onSelectType={handleSelectType} onClose={handleClose} userData={userData} />
      )}

      {currentStep === "simple" && (
        <SimplePublicationModal
          onClose={handleClose}
          onBack={handleBack}
          onPublish={handlePublishSimple}
          userData={userData}
        />
      )}

      {currentStep === "product" && (
        <ProductPublicationModal
          onClose={handleClose}
          onBack={handleBack}
          onPublish={handlePublishProduct}
          userData={userData}
        />
      )}
    </>
  )
}

const mapStateToProps = (state: any) => (
    {
    userData: state.general.userData,
})

export default connect(mapStateToProps, {openFeedTextModal, closeFeedTextModal, createPost, setPortfolio})(MainFeedModal)
